// extracted by mini-css-extract-plugin
export default {"button":"styles_button__kCwh3","primary":"styles_primary__bjBt3","secondary":"styles_secondary__ITupI","hover":"styles_hover__XXqOk"};